/**
 * Reusable date formatting utility for Division 26.
 * Converts between YYYY-MM-DD (backend/API format) and MM/DD/YYYY (US display format).
 */

/**
 * Format a date string from YYYY-MM-DD to MM/DD/YYYY.
 * Returns '-' for null/empty/invalid values.
 */
export const formatDateUS = (dateStr) => {
  if (!dateStr) return '-';
  const parts = dateStr.split('-');
  if (parts.length !== 3) return dateStr;
  const [year, month, day] = parts;
  return `${month}/${day}/${year}`;
};

/**
 * Parse a MM/DD/YYYY string back to YYYY-MM-DD for API submission.
 */
export const parseDateUS = (displayStr) => {
  if (!displayStr) return '';
  const parts = displayStr.split('/');
  if (parts.length !== 3) return displayStr;
  const [month, day, year] = parts;
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};
